import * as React from "react";
import SurahHeader from "./common/SurahHeader";
import Bismillah from "./Bismillah";

interface SurahBeginningProps {
  /** Surah number, 1-114. */
  number: number;
  /** Pages 1-2: the header matches their shorter lines. */
  compact?: boolean;
}

/**
 * Ornamental surah header and Bismillah as they open a surah in the mushaf.
 * Sits inside a shrink-to-fit text-mushaf block, so 1em is the mushaf font
 * size. The header spans the block, i.e. the page's widest line, and never
 * less than a typical full line (14.6em; most pages are 13.8-14.6em, a few
 * reach 15.1em; 10.5em on pages 1-2, whose lines are 9.4em). Being a size
 * container, it adds only that minimum to the block's width. Al-Fatiha's
 * Bismillah is its first ayah and At-Tawbah has none.
 */
const SurahBeginning: React.FC<SurahBeginningProps> = ({ number, compact = false }) => (
  <div className="select-none" translate="no">
    <SurahHeader
      number={number}
      className={compact ? "w-full min-w-[10.5em]" : "w-full min-w-[14.6em]"}
    />
    {number !== 1 && number !== 9 && <Bismillah />}
  </div>
);

export default React.memo(SurahBeginning);
